import { EventChannelList, notifyEventChannel } from 'helpers/event-center';

export default function openAddGroupModal() {
  notifyEventChannel(EventChannelList.QUOTE_PAGE_OPEN_GROUP_MODAL);
}
